import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const GuyTypingOnLaptop2 = ({ style }: SVGIconProps) => {
  return (
    <Center w="100%" style={style}>
      <svg
        width="400"
        height="283"
        viewBox="0 0 400 283"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="269.247"
          y="44.168"
          width="83.8018"
          height="114.225"
          rx="6.656"
          stroke="#C5C9F0"
          strokeWidth="1.932"
        />
        <path
          d="M283.453 84.9968H338.125"
          stroke="#C5C9F0"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M353.053 117.969C357.874 124.029 362.461 131.54 366.608 140.795C391.861 197.188 360.297 225.808 360.297 225.808"
          stroke="#C5C9F0"
          strokeWidth="1.6"
        />
        <path
          d="M89.2957 162.683C89.2957 162.683 51.8244 120.179 98.5508 99.1322C145.277 78.0857 154.528 75.1614 151.157 53.2682C147.786 31.375 174.285 9.08195 215.959 23.8133C257.632 38.5447 258.467 66.3061 255.512 87.7681C253.834 100.002 260.776 102.942 269.232 102.327"
          stroke="#C5C9F0"
          strokeWidth="1.6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M348.631 250.878C349.708 248.791 350.316 246.494 350.411 244.148C350.414 244.055 350.412 243.962 350.403 243.869C350.681 238.675 349.266 232.164 345.907 224.563V224.54C342.802 217.546 338.028 209.644 331.403 201.02L331.364 200.981C325.582 193.458 320.341 187.425 315.911 182.69C315.765 182.535 315.618 182.379 315.471 182.222C314.961 181.68 314.448 181.134 313.927 180.604C313.841 180.512 313.754 180.422 313.669 180.334C313.58 180.243 313.494 180.153 313.41 180.063C307.099 173.56 302.806 170.079 301.442 169.029C301.14 168.778 300.976 168.664 300.976 168.664C266.005 158.59 262.168 199.53 262.168 199.53H262.195L287.675 219.326L287.761 219.389C287.77 219.386 287.78 219.386 287.789 219.389C288.102 219.542 292.383 221.662 294.225 224.136C294.647 224.663 294.925 225.289 295.033 225.955C295.059 226.192 295.026 226.432 294.935 226.653C294.457 227.699 292.614 228.33 290.596 228.722C288.486 229.074 286.355 229.281 284.218 229.342C284.181 229.342 283.847 229.375 283.27 229.432C283.052 229.453 282.798 229.478 282.513 229.506L281.337 229.62C281.034 229.645 280.715 229.677 280.372 229.712C280.226 229.727 280.076 229.742 279.921 229.757L278.863 229.859C278.801 229.864 278.733 229.872 278.663 229.881C278.547 229.895 278.423 229.91 278.306 229.91L277.13 230.024C277.077 230.03 277.023 230.037 276.969 230.045C276.817 230.065 276.661 230.087 276.511 230.087C267.538 230.98 253.673 232.395 251.643 232.787C250.661 233.016 249.64 233.006 248.663 232.76C248.16 232.639 247.693 232.401 247.299 232.066L229.839 219.291C226.957 217.187 224.361 215.125 222.05 213.105C221.592 212.508 221.103 211.934 220.584 211.388C205.285 194.85 204.034 184.297 204.034 184.297C203.765 184.235 203.491 184.197 203.215 184.183C205.398 183.007 210.13 180.444 210.914 179.726C210.942 179.7 210.97 179.674 210.997 179.648C211.961 178.739 212.616 178.121 215.12 181.757C217.695 185.497 227.44 185.736 227.44 185.736C238.295 182.568 237.166 165.752 236.625 159.703C236.084 153.654 232.838 151.965 232.838 151.965C232.941 149.588 232.586 147.214 231.792 144.972C234.355 143.921 274.767 128.218 317.93 160.801C362.531 194.473 367.384 263.681 367.384 263.681H331.109C334.517 263.036 337.759 261.709 340.642 259.781L340.756 259.702C343.949 257.49 346.593 254.575 348.482 251.18C348.539 251.083 348.589 250.982 348.631 250.878ZM250.031 157.293C249.706 157.532 243.901 161.852 244.935 173.78C245.97 185.705 257.185 195.638 257.624 196.007C257.604 195.973 257.562 195.907 257.5 195.81C255.951 193.381 242.092 171.657 250.031 157.293Z"
          fill="#C5C9F0"
        />
        <path
          d="M223.006 171.439C222.577 171.755 222.129 172.045 221.666 172.309L218.977 167.605C225.178 164.434 226.919 158.844 224.19 155.774C223.427 154.935 222.444 154.326 221.352 154.018C218.608 153.187 216.707 154.41 215.417 156.053C214.365 157.481 213.593 159.096 213.144 160.812L211.834 145.712L211.733 144.536C211.733 144.536 208.879 143.121 201.149 144.383C193.418 145.645 191.995 149.914 188.675 148.021C185.355 146.127 183.473 146.28 183.473 146.28C182.529 149.749 180 149.749 180 149.749C179.401 149.677 178.813 149.534 178.248 149.322C174.661 146.025 173.689 140.306 173.689 140.306C177.452 139.84 177.742 136.218 177.311 133.25C179.396 134.489 182.336 134.575 186.464 131.925C198.307 124.352 210.451 128.452 214.72 129.083C216.625 129.362 218.71 128.691 220.439 127.907C220.662 128.307 220.973 128.652 221.348 128.915C224.23 130.922 226.606 133.571 228.291 136.653C239.404 157.425 227.22 168.456 223.006 171.439V171.439Z"
          fill="#3C0789"
        />
        <path
          d="M178.644 263.689H183.113C187.092 263.684 190.317 260.459 190.322 256.48V251.478C190.322 250.557 189.956 249.674 189.304 249.024C188.653 248.373 187.769 248.008 186.849 248.009H160.122C160.124 250.159 159.271 252.222 157.75 253.742C156.229 255.262 154.166 256.115 152.016 256.111H55.4385C55.4406 260.295 58.8319 263.687 63.0158 263.689H193.944C194.289 263.69 194.621 263.553 194.865 263.309C195.11 263.064 195.246 262.733 195.245 262.387V254.269C195.245 250.985 197.908 248.322 201.192 248.322C204.476 248.322 207.139 250.985 207.139 254.269V262.387C207.138 262.732 207.274 263.063 207.517 263.307C207.761 263.552 208.091 263.689 208.436 263.689H367.384C367.384 263.689 362.531 194.466 317.93 160.797C274.766 128.214 234.355 143.917 231.791 144.968L231.666 145.015"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M220.027 124.803C219.773 126.52 220.09 128.025 221.352 128.919C224.234 130.926 226.611 133.575 228.295 136.657C241.552 161.427 221.666 172.329 221.666 172.329L218.977 167.625C226.719 163.673 227.511 155.935 221.352 154.038C215.194 152.141 213.144 160.831 213.144 160.831L211.733 144.544C211.733 144.544 208.879 143.129 201.149 144.391C193.419 145.653 191.996 149.922 188.675 148.029C185.355 146.135 183.473 146.288 183.473 146.288C182.529 149.757 180 149.757 180 149.757C172.592 148.813 170.851 138.562 170.851 138.562C174.61 138.092 174.9 134.469 174.473 131.506C176.555 132.745 179.499 132.835 183.626 130.181C195.469 122.608 207.613 126.712 211.878 127.343C214.826 127.77 218.209 125.967 220.027 124.803V124.803Z"
          stroke="#3C0789"
          strokeWidth="1.932"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M226.864 247.641L229.792 246.465L231.987 252.388L231.642 263.137L228.675 263.674L217.413 263.188C217.413 263.188 218.197 256.633 220.592 253.517C222.987 250.401 226.864 247.641 226.864 247.641Z"
          fill="#FF5636"
        />
        <path
          d="M175.586 153.382C175.586 153.382 178.585 148 184.896 148.56"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M197.256 148.561C197.256 148.561 204.469 146.942 206.994 150.953"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M208.432 172.928C208.432 172.928 204.12 170.431 200.964 174.63"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M181.184 149.424C181.184 149.424 178.115 185.531 201.004 184.865C204.924 184.751 208.82 182.175 212.544 178.032"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M221.666 181.316L212.544 178.031C212.544 178.031 214.806 185.259 226.009 185.812C237.213 186.365 240.972 160.653 232.74 150.309"
          stroke="#3C0789"
          strokeWidth="1.932"
          strokeLinejoin="round"
        />
        <path
          d="M257.33 253.752C257.33 253.752 248.968 260.537 254.649 263.693"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M250.862 247.436C250.862 247.436 236.358 255.644 248.812 263.692"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M245.97 241.125C245.97 241.125 226.719 250.141 241.552 263.692"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M326.926 263.692C326.926 263.692 350.281 263.692 350.595 241.125C350.908 218.557 305.307 161.89 275.797 154.007C246.287 146.124 245.021 167.727 245.021 168.613C245.021 169.499 243.288 178.805 250.862 188.734C256.711 196.409 282.543 215.57 294.005 223.896C294.868 224.523 295.252 225.618 294.97 226.647C294.689 227.675 293.801 228.422 292.739 228.522L242.046 233.391H242.014C241.536 233.477 223.645 236.778 218.197 242.383C218.197 242.383 215.143 244.645 216.723 248.118C218.302 251.591 223.155 250.447 223.289 250.317"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <circle
          opacity="0.26"
          cx="200.184"
          cy="160.315"
          r="6.3112"
          fill="white"
        />
        <circle
          opacity="0.26"
          cx="184.167"
          cy="159.692"
          r="6.3112"
          fill="white"
        />
        <path
          d="M238.721 246.645C236.503 246.026 232.877 245.469 229.141 246.669C227.314 247.257 225.629 248.217 224.19 249.487C223.876 249.762 223.575 250.04 223.284 250.318C222.659 250.931 222.069 251.579 221.517 252.259C221.444 252.349 221.341 252.409 221.226 252.427C219.835 252.619 210.674 254.07 210.721 258.699C210.764 262.858 215.319 263.54 216.887 263.65C217.018 263.662 217.148 263.619 217.245 263.531C217.343 263.444 217.399 263.319 217.401 263.188C217.401 261.706 217.738 257.061 221.403 252.388"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M156.182 213.973C157.256 222.632 150.525 226.548 143.167 227.128"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M132.474 225.32C126.727 222.216 123.53 215.853 124.469 209.389C125.645 201.059 132.701 194.67 139.608 190.616C154.112 182.106 186.797 188.264 192.289 189.519C196.499 190.483 200.019 187.19 201.446 185.599C201.57 185.461 201.763 185.408 201.94 185.463C202.116 185.517 202.245 185.67 202.27 185.854C205.284 203.494 240.294 227.437 248.392 232.796"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M165.014 207.982L153.423 215.175C152.026 216.045 150.326 216.283 148.744 215.831C147.162 215.378 145.845 214.277 145.12 212.8C143.779 210.079 144.756 206.785 147.362 205.234L165.002 194.725"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <circle
          cx="200.184"
          cy="160.315"
          r="6.3112"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <circle
          cx="184.167"
          cy="159.693"
          r="5.36648"
          stroke="white"
          strokeWidth="1.6"
        />
        <circle
          cx="184.167"
          cy="159.694"
          r="6.3112"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path d="M193.905 159.694H190.479" stroke="#3C0789" strokeWidth="1.6" />
        <path
          d="M193.904 168.611H191.646C191.359 168.612 191.086 168.484 190.903 168.262C190.719 168.041 190.644 167.749 190.698 167.467L192.191 159.693"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M148.601 190.152C148.601 190.152 140.553 191.889 137.715 204.041C135.99 211.418 133.623 220.83 132.031 227.087C131.617 228.713 131.978 230.439 133.008 231.764C134.038 233.089 135.622 233.864 137.3 233.864C139.847 233.865 142.053 232.097 142.607 229.611L145.975 214.503"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M155.959 218.556C155.959 218.556 164.407 213.507 181.047 218.556C197.687 223.605 216.817 227.031 223.128 213.641"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M229.146 246.672C229.146 246.672 235.026 253.383 231.45 263.693"
          stroke="#3C0789"
          strokeWidth="1.6"
        />
        <path
          d="M34.8427 163.215H127.747C133.906 163.207 139.269 167.42 140.718 173.407L155.508 234.661C156.317 238.01 155.545 241.544 153.414 244.251C151.283 246.958 148.028 248.538 144.583 248.538H51.9182C45.7712 248.543 40.4177 244.344 38.9587 238.373L23.9294 177.131C23.1071 173.779 23.8709 170.234 26.0009 167.518C28.1309 164.802 31.391 163.215 34.8427 163.215V163.215Z"
          fill="white"
        />
        <path
          d="M38.2256 165.85H125.391C131.169 165.857 136.195 169.811 137.562 175.426L151.447 232.889C152.207 236.031 151.483 239.347 149.484 241.886C147.485 244.426 144.432 245.908 141.2 245.908H54.2467C48.4867 245.896 43.4752 241.962 42.0947 236.37L27.9827 178.903C27.2106 175.758 27.9275 172.432 29.9271 169.883C31.9266 167.335 34.9866 165.848 38.2256 165.85V165.85Z"
          fill="#3C0789"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.8427 163.215H127.747C133.906 163.207 139.269 167.42 140.718 173.407L155.508 234.661C156.317 238.01 155.545 241.544 153.414 244.251C151.283 246.958 148.028 248.538 144.583 248.538H51.9182C45.7712 248.543 40.4177 244.344 38.9587 238.373L23.9294 177.131C23.1071 173.779 23.8709 170.234 26.0009 167.518C28.1309 164.802 31.391 163.215 34.8427 163.215V163.215Z"
          stroke="#3C0789"
          strokeWidth="1.932"
        />
        <path
          d="M119.389 213.826H102.059C100.438 213.823 98.9713 212.864 98.3192 211.38C98.2203 211.156 98.167 210.915 98.1624 210.67C98.1709 209.686 98.9699 208.893 99.9538 208.891H118.378C117.511 210.357 117.951 212.383 119.389 213.826V213.826Z"
          fill="#E0E3FE"
        />
        <path
          d="M130.616 212.046C130.614 213.028 129.818 213.824 128.836 213.826H119.389C117.951 212.383 117.512 210.357 118.378 208.891H126.696C128.314 208.891 129.78 209.846 130.436 211.325C130.544 211.551 130.606 211.796 130.616 212.046V212.046Z"
          fill="#FF5636"
        />
        <path
          d="M126.261 213.827C126.212 213.922 126.156 214.012 126.092 214.098C124.854 215.787 122.172 215.944 120.091 214.423C119.842 214.243 119.608 214.044 119.389 213.827C117.951 212.385 117.512 210.358 118.378 208.892C118.426 208.799 118.483 208.71 118.546 208.626C119.773 206.924 122.466 206.775 124.536 208.285C124.787 208.47 125.024 208.673 125.246 208.892C126.696 210.335 127.116 212.361 126.261 213.827V213.827Z"
          fill="white"
        />
        <path
          d="M134.956 222.945C134.947 223.929 134.148 224.722 133.164 224.724H64.4779C65.356 223.25 64.9169 221.232 63.4744 219.793H131.059C132.679 219.793 134.145 220.751 134.795 222.235C134.896 222.458 134.951 222.7 134.956 222.945V222.945Z"
          fill="#FF5636"
        />
        <path
          d="M64.4778 224.705H55.9204C54.3019 224.705 52.8356 223.751 52.1807 222.27C52.0799 222.043 52.0266 221.798 52.0239 221.549C52.0229 221.077 52.2102 220.624 52.5443 220.291C52.8784 219.958 53.3317 219.771 53.8036 219.773H63.4742C64.9168 221.212 65.3558 223.231 64.4778 224.705V224.705Z"
          fill="#E0E3FE"
        />
        <path
          d="M64.4779 224.705C64.4377 224.801 64.385 224.892 64.3211 224.975C63.0942 226.677 60.4011 226.822 58.3275 225.312C58.0777 225.127 57.8419 224.924 57.6219 224.705C56.1911 223.262 55.752 221.247 56.6066 219.773C56.6542 219.678 56.7106 219.588 56.7751 219.503C58.0139 217.813 60.6951 217.657 62.7767 219.174C63.0251 219.354 63.2584 219.555 63.4744 219.773C64.917 221.212 65.356 223.231 64.4779 224.705V224.705Z"
          fill="white"
        />
        <path
          d="M70.5382 235.488H59.6641C58.0462 235.486 56.5809 234.532 55.9245 233.054C55.8167 232.835 55.7553 232.596 55.7441 232.352C55.7463 231.366 56.5453 230.567 57.5317 230.564H69.5151C68.6801 232.046 69.1074 234.061 70.5382 235.488V235.488Z"
          fill="#FF5636"
        />
        <path
          d="M138.684 233.736C138.671 234.715 137.868 235.499 136.888 235.488H70.5384C69.1076 234.045 68.6685 232.031 69.5231 230.557H134.787C136.407 230.556 137.873 231.515 138.523 232.999C138.627 233.231 138.681 233.482 138.684 233.736Z"
          fill="#E0E3FE"
        />
        <path
          d="M77.4062 235.489C77.3586 235.584 77.3022 235.675 77.2376 235.759C76.0107 237.46 73.3176 237.606 71.2479 236.096C70.9969 235.911 70.7598 235.708 70.5384 235.489C69.1076 234.046 68.6685 232.031 69.5231 230.557C69.5721 230.463 69.6285 230.372 69.6916 230.287C70.9304 228.597 73.6116 228.448 75.6932 229.958C75.9424 230.137 76.1758 230.338 76.3909 230.557C77.8335 232.012 78.2725 234.038 77.4062 235.489V235.489Z"
          fill="white"
        />
        <path
          d="M187.099 161.91C187.095 163.125 186.108 164.107 184.892 164.105C183.677 164.103 182.693 163.117 182.693 161.902C182.693 160.687 183.677 159.701 184.892 159.699C185.063 159.7 185.233 159.721 185.398 159.762C184.93 159.91 184.612 160.345 184.614 160.836C184.612 161.139 184.731 161.431 184.944 161.646C185.157 161.862 185.448 161.984 185.751 161.985C186.317 161.973 186.795 161.56 186.888 161.001C187.023 161.285 187.095 161.595 187.099 161.91V161.91Z"
          fill="#3C0789"
        />
        <path
          d="M202.392 162.525C202.393 163.42 201.855 164.227 201.029 164.571C200.203 164.914 199.252 164.726 198.619 164.094C197.986 163.462 197.796 162.511 198.138 161.684C198.48 160.857 199.286 160.318 200.181 160.318C200.286 160.318 200.392 160.329 200.494 160.354C200.095 160.538 199.839 160.937 199.84 161.377C199.821 161.783 200.021 162.168 200.364 162.387C200.707 162.606 201.14 162.625 201.501 162.438C201.862 162.25 202.095 161.885 202.113 161.479C202.294 161.798 202.39 162.158 202.392 162.525V162.525Z"
          fill="#3C0789"
        />
        <rect
          x="277"
          y="56"
          width="68"
          height="20"
          rx="3.328"
          stroke="#C5C9F0"
          strokeWidth="1.932"
        />
        <path
          d="M283.453 93.196H338.125"
          stroke="#C5C9F0"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M283.453 101.589H338.125"
          stroke="#C5C9F0"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M296.15 109.981H325.424"
          stroke="#C5C9F0"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </Center>
  );
};
